/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AccessService } from './services/AccessService';
import { AssessmentsService } from './services/AssessmentsService';
import { AuthorizationService } from './services/AuthorizationService';
import { BookmarksService } from './services/BookmarksService';
import { CoachService } from './services/CoachService';
import { ColabService } from './services/ColabService';
import { CompletionsService } from './services/CompletionsService';
import { CustomersService } from './services/CustomersService';
import { DefaultService } from './services/DefaultService';
import { ExercisesService } from './services/ExercisesService';
import { InvitationsService } from './services/InvitationsService';
import { MetadataService } from './services/MetadataService';
import { ProgramsService } from './services/ProgramsService';
import { ProgramVideosService } from './services/ProgramVideosService';
import { TargetsService } from './services/TargetsService';
import { TrainerDashboardService } from './services/TrainerDashboardService';
import { UsersService } from './services/UsersService';
import { VideosService } from './services/VideosService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class VideoPlatformClient {

    public readonly access: AccessService;
    public readonly assessments: AssessmentsService;
    public readonly authorization: AuthorizationService;
    public readonly bookmarks: BookmarksService;
    public readonly coach: CoachService;
    public readonly colab: ColabService;
    public readonly completions: CompletionsService;
    public readonly customers: CustomersService;
    public readonly default: DefaultService;
    public readonly exercises: ExercisesService;
    public readonly invitations: InvitationsService;
    public readonly metadata: MetadataService;
    public readonly programs: ProgramsService;
    public readonly programVideos: ProgramVideosService;
    public readonly targets: TargetsService;
    public readonly trainerDashboard: TrainerDashboardService;
    public readonly users: UsersService;
    public readonly videos: VideosService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://localhost:8788',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.access = new AccessService(this.request);
        this.assessments = new AssessmentsService(this.request);
        this.authorization = new AuthorizationService(this.request);
        this.bookmarks = new BookmarksService(this.request);
        this.coach = new CoachService(this.request);
        this.colab = new ColabService(this.request);
        this.completions = new CompletionsService(this.request);
        this.customers = new CustomersService(this.request);
        this.default = new DefaultService(this.request);
        this.exercises = new ExercisesService(this.request);
        this.invitations = new InvitationsService(this.request);
        this.metadata = new MetadataService(this.request);
        this.programs = new ProgramsService(this.request);
        this.programVideos = new ProgramVideosService(this.request);
        this.targets = new TargetsService(this.request);
        this.trainerDashboard = new TrainerDashboardService(this.request);
        this.users = new UsersService(this.request);
        this.videos = new VideosService(this.request);
    }
}

